<template>
    <toggle-button :color="color" :value="value" v-on:change="onChangeEventHandler" />
</template>

<script>
    import Vue from 'vue'
    import { ToggleButton } from 'vue-js-toggle-button'
    Vue.component('ToggleButton', ToggleButton)

    export default {
        name: 'ToggleSwitch',
        props: ['color', 'docId', 'value'],
        data () {
            return {
                msg: 'Welcome to Your Vue.js App'
            }
        },
        methods: {
            onChangeEventHandler: function (event) {
                this.$emit('toggleSwitchTransmit', {value: event.value, docId: this.docId})
            }
        }
    }
</script>

<!--
Eg:
<ToggleSwitch :value="list.featured" color="#5B3C51" :docId="list._id" @toggleSwitchTransmit="toggleSwitchResponse" />
-->

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    #progress-bar-line {
        max-width: 445px;
    }
</style>



// WEBPACK FOOTER //
// src/components/include/ToggleSwitch.vue